import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { environment } from 'environment';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiError } from './api';

const BACKEND_URL = environment.backendUrl + '/';
const LS_TOKEN = 'token';
const LS_SESSION = 'session';
const LS_PREV_LOGIN = 'previousLogin';
const LS_DISPLAY_NAME = 'displayName';
const LS_OBJECT_ID = 'objectId';
const LS_ROLE_ID = 'roleId';
const LS_COMPANY_ID = 'companyId';

export interface ErrorResponse {
  headers: Headers;
  ok: boolean;
  status: number;
  statusText: string;
  type: number;
  url: string;
  _body: string;
}

@Injectable()
export class Rest {

  public session: string = localStorage.getItem(LS_SESSION);
  public token: string = localStorage.getItem(LS_TOKEN);
  public authenticated = false;

  private extractor: (value: Response, index: number) => any;

  constructor(
    public http: HttpClient
  ) {
    this.extractor = this.extract.bind(this);
  }

  setSessionToken(session: string, token: string) {
    localStorage.setItem(LS_SESSION, session);
    localStorage.setItem(LS_TOKEN, token);
    this.session = session;
    this.token = token;
    this.authenticated = false;
  }

  getBackend(query: string): Observable<any> {
    const headers = this.getDefHeaders();
    return this.http.get(BACKEND_URL + query, {headers}).pipe(
      map(this.extractor),
      catchError(error => this.handleError(error)));

  }

  postBackend(query: string, data: any, domain?: string): Observable<any> {
    const body = JSON.stringify(data);
    const headers = this.getDefHeaders(domain);
    return this.http.post(BACKEND_URL + query, body, {headers}).pipe(
      map(this.extractor),
      catchError(error => this.handleError(error)));
  }

  putBackend(query: string, data: any): Observable<any> {
    const body = JSON.stringify(data);
    const headers = this.getDefHeaders();
    return this.http.put(BACKEND_URL + query, body, {headers}).pipe(
      map(this.extractor),
      catchError(error => this.handleError(error)));
  }

  deleteBackend(query: string, data?: any): Observable<any> {
    const body = JSON.stringify(data);
    const headers = this.getDefHeaders();
    return this.http.delete(BACKEND_URL + query, {headers, body}).pipe(
      map(this.extractor),
      catchError(error => this.handleError(error)));
  }

  private getDefHeaders(model?: string) {
    return new HttpHeaders({
      'Authorization': this.token ? 'Bearer ' + this.token : undefined,
      'Content-Type': 'application/json' + (model ? '; domain-model=' + model : '')
    });
  }

  private extract(res: Response) {
    const token = res.headers?.get('Token');
    if (token) {
      localStorage.setItem(LS_TOKEN, token);
      this.token = token;
    }
    if (res) {
      return res;
    } else {
      return observableThrowError('No response');
    }
  }

  private handleError(error: ErrorResponse) {
    const err: ApiError = JSON.parse(error._body);
    err.code = error.status;
    if (error && error.status === 401) {
      this.clearSessionToken();
      // CHANGE MESSAGE FROM BACKEND (REQUESTED)!!!
      if (err.message.startsWith('Token')) {
        err.message = 'Session expired';
      }
    }
    return observableThrowError(err);
  }

  private clearSessionToken() {
    localStorage.removeItem(LS_SESSION);
    localStorage.removeItem(LS_TOKEN);
    localStorage.removeItem(LS_PREV_LOGIN);
    this.session = null;
    this.token = null;
    this.authenticated = false;
  }

  postFile(query: string, data: any): Observable<any> {
    // let headers = new Headers({ 'Content-Type': 'application/json; multipart/form-data; application/octet-stream;' });
    const headers = new HttpHeaders({ 'Content-Type': 'application/octet-stream;' });
    return this.http.post('https://74w71joe8d.execute-api.us-east-1.amazonaws.com/orm/upload' + query, data, {headers}).pipe(
      map(this.extractor),
      catchError(error => this.handleError(error)));
  }

}
